"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterstitialManager = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const features_1 = require("../features");
const initializer_1 = require("../initializer");
const interstitialManagerBase_1 = require("./interstitialManagerBase");
const InterstitialManager = ({ interstitialConfig }) => {
    const interstitialsRepository = new features_1.InterstitialsRepository(initializer_1.API);
    return (0, jsx_runtime_1.jsx)(interstitialManagerBase_1.InterstitialManagerBase, { interstitialsRepository: interstitialsRepository, interstitialConfig: interstitialConfig });
};
exports.InterstitialManager = InterstitialManager;
//# sourceMappingURL=interstitialManager.js.map